// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 496 ? "graphql-print" : chunkId) + "." + {"5":"cc4bf673432c8179","261":"7120ec1cb358bfa1","496":"83edc8afc0370428"}[chunkId] + ".js";
};